$(window).on('load', function () {
  $('form input[type="submit"]').removeAttr('disabled');
  var ww = $(window).width();
  if (ww > 768) {
    var imgbott = function imgbott() {
      var heightForm = $('.imgbott .form__item').height() + 78;
      var heightText = $('.imgbott .imgbott-text').height() + 26;
      var heightImg = heightForm - heightText + 50;
      //console.log('heightForm - '+heightForm);
      //console.log('heightText - '+heightText);
      //console.log('heightImg - '+heightImg);
      $('.imgbott .form__content img').css('max-height', heightImg + 'px');
    };
    setTimeout(imgbott, 500);
  }
  $(".message__img").click(function () {
    $('.message__content').toggle();
  });
  $(document).on('click', function (e) {
    if (!$(e.target).closest(".message").length) {
      $('.message__content').hide();
    }
    e.stopPropagation();
  });
  $('.resources-grid__share').click(function (e) {
    e.preventDefault();
    $(this).parent().find('.resources-grid__sharediv').slideToggle();
  });
  $('.tabs-area-slider').on('click', function () {
    $(this).find('.tabs__items[index="0"]').find('.tabs-area-slider-info').attr('active');
  });
  function herovideo() {
    var ww = $('body').innerWidth();
    var hh = $(window).height();
    var hhi = hh - 20;
    var hh10 = $('.videoimg').outerHeight();
    var hh11 = $('.banner__bottom .modalVideo').outerHeight();
    var hh12 = $('.banner .modalVideo').outerHeight();
    var hh13 = $('.streamline .modalVideo').outerHeight();
    var viw10 = $('.videoimg').width();
    var viw11 = $('.banner__bottom .modalVideo').width();
    var viw12 = $('.banner .modalVideo').width();
    var viw13 = $('.streamline .modalVideo').width();
    var pro = 1.777777778;
    var vih10 = viw10 / pro;
    var vih11 = viw11 / pro;
    var vih12 = viw12 / pro;
    var vih13 = viw13 / pro;
    $('.videoimg').css('height', vih10);
    $('.banner__bottom .modalVideo').css('height', vih11);
    $('.banner .modalVideo').css('height', vih12);
    $('.streamline #modalVideo').css('height', vih13);
    if (hhi < hh12) {
      //$('.banner .modalVideo').css('width', hh12*pro);
    }
    var viw21 = $('.banner__bottom .modalVideo').outerHeight();
    var clb1 = viw21 / 2 - 20;
    $('.banner__bottom a.closeBtn').css('margin-top', '-' + clb1 + 'px');
    var viw22 = $('.banner .modalVideo').outerHeight();
    var clb2 = viw22 / 2 - 20;
    $('.banner a.closeBtn').css('margin-top', '-' + clb2 + 'px');
    var viw23 = $('.streamline #modalVideo').outerHeight();
    var clb3 = viw23 / 2 - 20;
    $('.streamline a.closeBtn').css('margin-top', '-' + clb3 + 'px');
    $('.whitePreloader').remove();
    $('.videoimg').removeClass('videoimg-whitebl');
  }
  herovideo();
  $('[data-popup="bannerPopup"]').fancybox({
    baseClass: 'fancybox-container-video',
    smallBtn: true,
    afterLoad: function afterLoad(instance, current) {
      current.$content.wrapInner('<div class="fancybox-content-video"></div>');
    }
  });
  $('.controlsYes').fancybox({
    video: {
      tpl: '<video class="fancybox-video" controls controlsList="nodownload">' + '<source src="{{src}}" type="{{format}}" />' + "Your browser doesn't support HTML5 video" + "</video>",
      format: ""
    },
    baseClass: 'fancybox-container-video',
    smallBtn: true,
    afterLoad: function afterLoad(instance, current) {
      current.$content.wrapInner('<div class="fancybox-content-video"></div>');
    }
  });
  $('.controlsNo').fancybox({
    video: {
      tpl: '<video class="fancybox-video" controlsList="nodownload">' + '<source src="{{src}}" type="{{format}}" />' + "Your browser doesn't support HTML5 video" + "</video>",
      format: ""
    },
    baseClass: 'fancybox-container-video',
    smallBtn: true,
    afterLoad: function afterLoad(instance, current) {
      current.$content.wrapInner('<div class="fancybox-content-video"></div>');
    }
  });
  $(window).on('load resize', function () {
    var windowWidth = $('body').innerWidth();
    herovideo();
    if (windowWidth > 768) {
      $('.tab-nav li:first').addClass('select');
      $('.tab-panels>div').hide().filter(':first').show();
      $('.tab-nav a').click(function () {
        $('.tab-panels>div').hide().filter(this.hash).show();
        $('.tab-nav li').removeClass('select');
        $(this).parent().addClass('select');
        return false;
      });
    } else {
      $('.tab-panels>div').show();
    }
    if (windowWidth > 768) {
      var heightForm = $('.imgbott .form__item').height() + 78;
      var heightText = $('.imgbott .imgbott-text').height() + 26;
      var heightImg = heightForm - heightText + 50;
      //console.log('heightForm - '+heightForm);
      //console.log('heightText - '+heightText);
      //console.log('heightImg - '+heightImg);
      $('.imgbott .form__content img').css('max-height', heightImg + 'px');
    }
  });
  $(function () {
    $('.partners-nav li:first').addClass('select');
    $('.partners-panels>div').hide().filter(':first').show();
    $('.partners-nav a').click(function () {
      $('.partners-panels>div').hide().filter(this.hash).show();
      $('.partners-panels>div').removeClass('showpart').filter(this.hash).addClass('showpart');
      $('.partners-nav li').removeClass('select');
      $(this).parent().addClass('select');
      return false;
    });
  });

  //download
  $(function () {
    $('.download__tab li:first').addClass('select');
    $('.download__panels > .download__items').hide().filter(':first').show();
    $('.download__tab a').click(function () {
      $('.download__panels > div').hide().filter(this.hash).show();
      $('.download__panels .download__item').fadeOut().filter(this.hash).fadeIn();
      $(this.hash).find('.download__item').fadeIn();
      $('.download__tab li').removeClass('select');
      $(this).parent().addClass('select');
      return false;
    });
  });

  //SLIDER

  $('.slick-ban-tab2').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    asNavFor: '.slick-nav-tab2',
    vertical: true,
    responsive: [{
      breakpoint: 1040,
      settings: {
        infinite: true,
        dots: true,
        vertical: false
      }
    }]
  });
  if ($(window).width() > 1040) {
    $('.slick-nav-tab2').slick({
      slidesToShow: 100,
      slidesToScroll: 1,
      asNavFor: '.slick-ban-tab2',
      focusOnSelect: true,
      vertical: true
    });
  }
  $('.slick-ban-tab3').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    asNavFor: '.slick-nav-tab3',
    vertical: true,
    responsive: [{
      breakpoint: 1040,
      settings: {
        vertical: false,
        infinite: false,
        dots: false,
        centerMode: true,
        centerPadding: '40px'
      }
    }]
  });
  $('.slick-nav-tab3').slick({
    slidesToShow: 11,
    slidesToScroll: 1,
    asNavFor: '.slick-ban-tab3',
    focusOnSelect: true,
    vertical: true,
    responsive: [{
      breakpoint: 1040,
      settings: {
        vertical: false
      }
    }]
  });

  //Wrappper

  $(window).on('load resize', function () {
    var windowWidth = $('body').innerWidth();
    var wrapWidth = $('.tab-slider > .wrapper').width();
  });
  $('form #products').change(function () {
    var thch = $(this).val();
    var prodval = $('#prods').val();
    var selprod = $('.selprod');
    if (prodval === '') {
      if (prodvaln === undefined) {
        var prodvaln = thch;
        $('#prods').val(prodvaln);
        $(selprod).append('<div class="sla"><div class="valpr">' + prodvaln + '</div><span>+</span></div>');
      } else {
        var prodvaln = prodvaln + thch;
        $('#prods').val(prodvaln);
        $(selprod).append('<div class="sla"><div class="valpr">' + thch + '</div><span>+</span></div>');
      }
    } else {
      if (prodval.indexOf(thch) == -1) {
        var prodvaln = prodval + ', ' + thch;
        $('#prods').val(prodvaln);
        $(selprod).append('<div class="sla"><div class="valpr">' + thch + '</div><span>+</span></div>');
      } else {
        var prodvaln = prodval;
      }
    }
    //console.log($('#prods').val());
  });

  $('.selprod').on('click', '.sla', function () {
    var valpr = $(this).find('.valpr').text();
    var prodval = $('#prods').val();
    var tht1 = prodval.replace(valpr, "");
    var tht2 = tht1.replace(', ,', ",");
    $(this).remove();
    var sl = tht2.length;
    var vv = valpr.length;
    var sl1 = sl - 1;
    var s = tht2;
    var petName = tht2;
    var x = petName.length - 2;
    if (petName[x] == ",") {
      var tht21 = tht2.slice(0, -1);
      var tht22 = tht21.slice(0, -1);
      var tht2 = tht22;
    } else if (petName[0] == ",") {
      var tht21 = tht2.slice(1);
      var tht21 = tht21.slice(1);
      var tht2 = tht21;
    }
    $('#prods').val(tht2);
  });
  $('.notpop').click(function () {
    $(this).hide();
    $('#posterbanner').hide();
    $('#videoBack').fadeIn();
  });
  $(window).on('load resize', function () {
    var windowWidth = $('body').innerWidth();
    if (windowWidth < 769) {
      // Перемещаем параграф из #myDiv1 в #myDiv2
      $('.form__item').append($('.form__content>img'));
    }
  });
  $(window).on('load resize', function () {
    var windowWidth = $('body').innerWidth();
    var wrapWidth = $('.tab-box').width();
    var wrapH = $('.tabs-area > h3').width();
    if (windowWidth > 1440) {
      //console.log(maxwrapWidth)
      var maxwrapWidth = +((windowWidth - 1440) / 2) + 1271;
      $('.tab-box').css('max-width', maxwrapWidth);
      $('.tabs-area > h3').css('max-width', maxwrapWidth);
    }
  });
  $('.resources-grid__btn').on('click', function (e) {
    $('.resources-grid__btn').removeClass('active');
    if ($(this).hasClass('grid')) {
      $('.resources-grid__list').addClass('grid-item');
      $(this).addClass('active');
    } else if ($(this).hasClass('list')) {
      $('.resources-grid__list').removeClass('grid-item');
      $(this).addClass('active');
    }
  });

  //Resources SELECT

  $('.select').on('click', '.select__head', function () {
    if ($(this).hasClass('open')) {
      $(this).removeClass('open');
      $(this).next().fadeOut();
    } else {
      $('.select__head').removeClass('open');
      $('.select__list').fadeOut();
      $(this).addClass('open');
      $(this).next().fadeIn();
    }
  });
  $('.page-template-resources .select').on('click', '.select__item', function () {
    $('.select__head').removeClass('open');
    $(this).parent().fadeOut();
    $(this).parent().prev().text($(this).text());
    $(this).parent().prev().prev().val($(this).attr('data-val'));
    var thisform = $('#formfilter');
    var raspars = $(thisform).serialize();
    //console.log(raspars);
    window.history.pushState("More4apps Resources", "Resources", "/resources/?" + raspars);
    $.ajax({
      type: 'GET',
      url: '/wp-content/themes/more4app-1941/search-resources.php',
      cache: false,
      dataType: 'html',
      data: $(thisform).serialize(),
      success: function success(data) {
        $('.resources-grid__list').html(data);
      }
    });
  });
  $(document).on('click', '.rtaglink', function (e) {
    e.preventDefault();
    var rtaglink = $(this).attr('data-slug');
    $('#idtag').val(rtaglink);
    var thisform = $('#formfilter');
    var raspars = $(thisform).serialize();
    window.history.pushState("More4apps Resources", "Resources", "/resources/?" + raspars);
    $.ajax({
      type: 'GET',
      url: '/wp-content/themes/more4app-1941/search-resources.php',
      cache: false,
      dataType: 'html',
      data: $(thisform).serialize(),
      success: function success(data) {
        $('.resources-grid__list').html(data);
      }
    });
  });
  $('#formfilter input').change(function () {
    var thisform = $('#formfilter');
    $.ajax({
      type: 'GET',
      url: '/wp-content/themes/more4app-1941/search-resources.php',
      cache: false,
      dataType: 'html',
      data: $(thisform).serialize(),
      success: function success(data) {
        $('.resources-grid__list').html(data);
      }
    });
  });
  $('#formfilterSupport input').change(function () {
    var thisform = $('#formfilterSupport');
    $.ajax({
      type: 'GET',
      url: '/wp-content/themes/more4app-1941/search-support.php',
      cache: false,
      dataType: 'html',
      data: $(thisform).serialize(),
      success: function success(data) {
        $('.resources-grid__list').html(data);
      }
    });
  });
  $('.page-template-support .select').on('click', '.select__item', function () {
    $('.select__head').removeClass('open');
    $(this).parent().fadeOut();
    $(this).parent().prev().text($(this).text());
    $(this).parent().prev().prev().val($(this).attr('data-val'));
    var thisform = $('#formfilterSupport');
    var raspars = $(thisform).serialize();
    window.history.pushState("More4apps Support", "Support", "/support/support-search/?" + raspars);
    $.ajax({
      type: 'GET',
      url: '/wp-content/themes/more4app-1941/search-support.php',
      cache: false,
      dataType: 'html',
      data: $(thisform).serialize(),
      success: function success(data) {
        $('.resources-grid__list').html(data);
      }
    });
  });
  $('.select-sort .select__item').click(function () {
    $('#sortform').val($(this).attr('data-sort'));
  });
  $(document).on('click', '.rtaglinkS', function (e) {
    e.preventDefault();
    var rtaglink = $(this).attr('data-slug');
    $('#idtag').val(rtaglink);
    var thisform = $('#formfilterSupport');
    var raspars = $(thisform).serialize();
    window.history.pushState("More4apps Support", "Support", "/support/support-search/?" + raspars);
    $.ajax({
      type: 'GET',
      url: '/wp-content/themes/more4app-1941/search-support.php',
      cache: false,
      dataType: 'html',
      data: $(thisform).serialize(),
      success: function success(data) {
        $('.resources-grid__list').html(data);
      }
    });
  });
  $(document).click(function (e) {
    if (!$(e.target).closest('.select').length) {
      $('.select__head').removeClass('open');
      $('.select__list').fadeOut();
    }
  });

  //SIDEBAR
  $('.filters-sidebar').on('click', function () {
    $('.resources-sidebar__inner').addClass('sidebar-show');
    $('body').toggleClass('overflowh');
  });
  $('.sidebar-closeBtn').on('click', function () {
    $('.resources-sidebar__inner').removeClass('sidebar-show');
    $('body').toggleClass('overflowh');
  });
  //SIDEBAR

  $('.head').click(function () {
    $(this).toggleClass('active');
    $(this).parent().find('.arrow').toggleClass('arrow-animate');
    $(this).parent().find('.content').slideToggle(280);
  });

  //-----TEAM MODAL-----

  settings = {
    objModalPopupBtn: ".modalButtonTeam",
    objModalCloseBtn: ".modaloverlay, .closeBtnTeam",
    objModalDataAttr: "data-popup"
  };
  $(settings.objModalPopupBtn).bind("click", function (e) {
    if ($(this).attr(settings.objModalDataAttr)) {
      var strDataPopupName = $(this).attr(settings.objModalDataAttr);
      //$(".overlay, #" + strDataPopupName).fadeIn();
      $(".over" + strDataPopupName + ", #" + strDataPopupName).fadeIn();
      //console.log($(".overlay, #" + strDataPopupName));
      e.preventDefault();
      $('body').toggleClass('opmodal');
    }
  });
  $(settings.objModalCloseBtn).bind("click", function (e) {
    $(".modaloverlay").fadeOut();
    $(".modal").fadeOut();
    $('body').toggleClass('opmodal');
    e.preventDefault();
  });
  //-----MODAL-----
  // Search 
  $('#serchresbut').click(function () {
    if (typeof $('#serchres').attr('data-url') == 'undefined' || !$('#serchres').attr('data-url')) return;
    location.href = $('#serchres').attr('data-url') + '/?search=' + $('#serchres').val();
  });
  $('#serchresbut_m').click(function () {
    if (typeof $('#serchres_m').attr('data-url') == 'undefined' || !$('#serchres_m').attr('data-url')) return;
    location.href = $('#serchres_m').attr('data-url') + '/?search=' + $('#serchres_m').val();
  });
  $('#serchres').keypress(function (e) {
    var key = e.which;
    if (key == 13) {
      location.href = $('#serchres').attr('data-url') + '/?search=' + $('#serchres').val();
      return false;
    }
  });
});